import { render, staticRenderFns } from "./StockDebt.vue?vue&type=template&id=70e05c18&scoped=true"
import script from "./StockDebt.vue?vue&type=script&lang=js"
export * from "./StockDebt.vue?vue&type=script&lang=js"
import style0 from "./StockDebt.vue?vue&type=style&index=0&id=70e05c18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e05c18",
  null
  
)

export default component.exports